<template lang="pug">
.section
  .section-header
    h1 {{ $t("ui.mission") }}
  .section-body
    .row
      .col-12
        .card.mb-0
          .card-header
            .row
              .form-group.col-12.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="fa fa-sync"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getMissionList()"
                  variant="primary"
                  size="sm"
                )
          .card-body
            .row
              .col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changedPage($event)"
                )
              .col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
            .row
              .col-12.clusterize-scroll.table-responsive
                table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                  thead.thead-light
                    tr
                      //- th.text-center(width="4%")
                      //-   span #
                      th.text-center(width="6%")
                        span {{ $t('ui.id') }}
                      th(width="22%")
                        span {{ $t('ui.title') }}
                      th.text-center(width="8%")
                        span {{ $t('ui.repeatable') }}
                      th.text-center(width="6%")
                        span {{ $t('ui.status') }}
                      th(width="24%")
                        span {{ $t('ui.reward') }}
                      th(width="30%")
                        span {{ $t('ui.rules') }}
                  tbody.clusterize-content
                    tr(v-if="missionList.length == 0")
                      td(colspan="6").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(
                      v-for="(item, index) in missionList"
                      :key="item.mission_id != null ? item.mission_id : index"
                    )
                      //- td.text-center
                      //-   span(:title="index + 1") {{ index + 1 }}
                      td.text-center
                        span(:title="item.mission_id") {{ item.mission_id }}
                      td
                        .mission-title {{ item.title_en }}
                        .mission-title-row.text-muted.small(v-if="item.title_cn") {{ item.title_cn }}
                        .mission-title-row.text-muted.small(v-if="item.title_local") {{ item.title_local }}
                      td.text-center
                        i.fa(
                          :class="item.repeatable ? 'fa-check text-success' : 'fa-times text-danger'"
                          aria-hidden="true"
                        )
                      td.text-center
                        .d-flex.justify-content-center.align-items-center
                          label.custom-switch.mb-0
                            input.custom-switch-input(
                              type="checkbox"
                              v-model="item.status"
                              @change="isMissionEditAccess ? onMissionStatusChange(item, $event) : null"
                              :disabled="!isMissionEditAccess || statusUpdatingId === item.mission_id"
                            )
                            span.custom-switch-indicator
                      td.mission-reward-td
                        .mission-reward
                          .mission-reward-chips(
                            :role="isMissionEditAccess ? 'button' : 'group'"
                            :aria-label="isMissionEditAccess ? $t('ui.combine.edit_mission_reward') : $t('ui.reward')"
                            :class="{ 'is-clickable': isMissionEditAccess }"
                            :tabindex="isMissionEditAccess ? 0 : -1"
                            @click="isMissionEditAccess ? onEditMissionGlobal(item) : null"
                            @keydown.enter.prevent="isMissionEditAccess ? onEditMissionGlobal(item) : null"
                            @keydown.space.prevent="isMissionEditAccess ? onEditMissionGlobal(item) : null"
                          )
                            .mission-reward-grid
                              .mission-reward-row(
                                v-for="(row, ri) in missionRewardGridRows(item)"
                                :key="'mr-' + item.mission_id + '-r' + ri"
                              )
                                .mission-reward-slot(
                                  v-for="(tok, ci) in row"
                                  :key="'mr-' + item.mission_id + '-r' + ri + '-c' + ci"
                                )
                                  template(v-if="tok")
                                    .mission-reward-token(
                                      :class="tok.tokenClass"
                                      :title="tok.label + ': ' + tok.display"
                                    )
                                      span.mission-reward-token-ic(aria-hidden="true")
                                        i.fa(:class="tok.iconClass")
                                      span.sr-only {{ tok.label }}: {{ tok.display }}
                                      span.mission-reward-token-val(
                                        :class="{ 'is-campaign': tok.key === 'campaign' }"
                                      ) {{ tok.display }}
                                  span.mission-reward-slot-empty(
                                    v-else
                                    aria-hidden="true"
                                  )
                      td.mission-rules-td
                        .mission-rules-stack(v-if="item.rules_parsed && item.rules_parsed.length")
                          .mission-rule-card(
                            v-for="(rule, ri) in item.rules_parsed"
                            :key="'rl-' + item.mission_id + '-' + ri"
                            :class="{ 'is-clickable': canEditMissionRuleCard(item) }"
                            :role="canEditMissionRuleCard(item) ? 'button' : 'group'"
                            :tabindex="canEditMissionRuleCard(item) ? 0 : -1"
                            :aria-label="ruleCardAriaLabel(item, rule)"
                            @click="canEditMissionRuleCard(item) ? openRuleEditor(item, ri) : null"
                            @keydown.enter.prevent="canEditMissionRuleCard(item) ? openRuleEditor(item, ri) : null"
                            @keydown.space.prevent="canEditMissionRuleCard(item) ? openRuleEditor(item, ri) : null"
                          )
                            .mission-rule-grid
                              .mission-rule-row
                                .mission-rule-slot
                                  .mission-rule-pill.mission-rule-pill--event(
                                    :title="rule.event_type"
                                  )
                                    span.mission-rule-pill-ic(aria-hidden="true")
                                      i.fa.fa-random
                                    span.sr-only {{ rule.event_type }}
                                    span.mission-rule-pill-txt {{ rule.event_type }}
                                .mission-rule-slot
                                  .mission-rule-pill.mission-rule-pill--mode(
                                    :title="formatEvalMode(rule)"
                                  )
                                    span.mission-rule-pill-ic(aria-hidden="true")
                                      i.fa.fa-sliders-h
                                    span.sr-only {{ formatEvalMode(rule) }}
                                    span.mission-rule-pill-txt {{ formatEvalMode(rule) }}
                              .mission-rule-row
                                .mission-rule-slot
                                  .mission-rule-pill.mission-rule-pill--detail
                                    .mission-rule-pill-stack
                                      span.mission-rule-pill-lbl {{ $t('ui.target') }}
                                      span.mission-rule-pill-strong {{ formatRuleTarget(rule) }}
                                .mission-rule-slot
                                  template(v-if="hasEventFilter(rule)")
                                    .mission-rule-pill.mission-rule-pill--detail
                                      .mission-rule-pill-stack
                                        span.mission-rule-pill-lbl {{ $t('ui.event_filter') }}
                                        span.mission-rule-pill-strong(
                                          :title="formatEventFilter(rule)"
                                        ) {{ formatEventFilter(rule) }}
                                  span.mission-reward-slot-empty(
                                    v-else
                                    aria-hidden="true"
                                  )
                        span.text-muted(v-else) —
            editmissionglobal(
              ref="editmissionglobal"
              :item="selectedMission"
              :submit-as-status-enable="missionGlobalSubmitAsStatusEnable"
              @clicked="afterEditMissionGlobal"
              @failed="handleFailed"
              @status-enable-cancelled="onMissionStatusEnableCancelled"
            )
            b-modal#editMissionRuleModal(
              ref="editMissionRuleModal"
              :title="ruleModalTitle"
              centered
              no-fade
              :busy="ruleSaveLoading"
              @ok="onRuleModalOk"
              @shown="onRuleModalShown"
              @hidden="onRuleModalHidden"
            )
              b-form(@submit.stop.prevent="saveMissionRuleTarget")
                .small.text-muted.mb-2(v-if="ruleEditSummary") {{ ruleEditSummary }}
                b-form-group(:label="$t('ui.target')").mb-0
                  DebounceInput(
                    size="sm"
                    ref="ruleTargetInput"
                    type="text"
                    :dirty="$v.ruleEditTargetInput.$dirty"
                    :error="$v.ruleEditTargetInput.$error"
                    v-model.trim.lazy="$v.ruleEditTargetInput.$model"
                    :disabled="ruleSaveLoading"
                  )
                  ValidateResult(:value="$v.ruleEditTargetInput" :name="$t('ui.target')")
              div(slot="modal-cancel")
                SubmitButton(
                  :loading="ruleSaveLoading"
                  icon="fa fa-ban"
                  :text="$t('ui.cancel')"
                  isModal=true
                )
              div(slot="modal-ok")
                SubmitButton(
                  :loading="ruleSaveLoading"
                  icon="fa fa-save"
                  :text="$t('ui.save')"
                  isModal=true
                )
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import editmissionglobal from "@/components/mission/editMissionGlobal.vue";
import { required, decimal } from "vuelidate/lib/validators";
import ValidateResult from "@/library/ValidateResult";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    editmissionglobal,
    ValidateResult
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    list: [],
    currentPage: 1,
    totalRow: 0,
    statusUpdatingId: null,
    missionList: [],
    selectedMission: null,
    missionGlobalSubmitAsStatusEnable: false,
    ruleEditMission: null,
    ruleEditIndex: null,
    ruleEditRuleSnapshot: null,
    ruleEditTargetInput: "",
    ruleSaveLoading: false,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isMissionEditAccess() {
      return this.$helpers.showActionButton("e_globalmission");
    },
    ruleModalTitle() {
      return this.$t("ui.edit") + " — " + this.$t("ui.target");
    },
    ruleEditSummary() {
      const m = this.ruleEditMission;
      const r = this.ruleEditRuleSnapshot;
      if (!m || !r) {
        return "";
      }
      const title = m.title_en || m.mission_id;
      const ev = r.event_type != null ? String(r.event_type) : "";
      const mode = this.formatEvalMode(r);
      return [title, ev, mode].filter(Boolean).join(" · ");
    },
  },
  validations: {
    ruleEditTargetInput: {
      required,
      decimal
    }
  },
  mounted: function() {
    this.getMissionList();
  },
  methods: {
    changedPageSize(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPage = 1;
      this.getMissionList(true);
    },
    changedPage(pageNo) {
      this.currentPage = pageNo;
      this.getMissionList();
    },
    parseJson(val) {
      if (val == null || val === "") {
        return null;
      }
      if (typeof val === "object") {
        return val;
      }
      if (typeof val === "string") {
        try {
          return JSON.parse(val);
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    humanizeRewardKey(key) {
      const labels = {
        badge: "Point",
        credit: "Credit",
        inbox: "Inbox",
        campaign: "Campaign"
      };
      if (labels[key]) {
        return labels[key];
      }
      return String(key)
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase());
    },
    parseRewardAmount(v) {
      if (v === null || v === undefined || v === "") {
        return null;
      }
      if (typeof v === "number") {
        return Number.isFinite(v) ? v : null;
      }
      if (typeof v === "string") {
        const t = v.trim();
        if (t === "") {
          return null;
        }
        const n = Number(t.replace(/,/g, ""));
        return Number.isFinite(n) ? n : null;
      }
      return null;
    },
    formatRewardDisplayValue(v, rewardKey) {
      const k = String(rewardKey || "")
        .toLowerCase()
        .trim();
      if (v === null || v === undefined) {
        return "";
      }
      if (typeof v === "string" && v.trim() === "") {
        return "";
      }
      if (typeof v === "boolean") {
        return v ? this.on : this.off;
      }
      if (k === "badge" || k === "credit" || k === "inbox") {
        const n = this.parseRewardAmount(v);
        if (n != null) {
          return this.$n(n, "currency");
        }
        return "";
      }
      if (typeof v === "number") {
        return Number.isInteger(v) ? String(v) : String(v);
      }
      return String(v);
    },
    rewardEntriesFromPayload(payload) {
      const obj = this.parseJson(payload);
      if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
        return [];
      }
      return Object.keys(obj).map(key => ({
        key,
        label: this.humanizeRewardKey(key),
        display: this.formatRewardDisplayValue(obj[key], key)
      }));
    },
    rewardTokenVisual(key) {
      const k = String(key || "")
        .toLowerCase()
        .trim();
      const map = {
        badge: {
          iconClass: "fa-trophy",
          tokenClass: "mission-reward-token--badge"
        },
        credit: {
          iconClass: "fa-credit-card",
          tokenClass: "mission-reward-token--credit"
        },
        inbox: {
          iconClass: "fa-inbox",
          tokenClass: "mission-reward-token--inbox"
        },
        campaign: {
          iconClass: "fa-bullhorn",
          tokenClass: "mission-reward-token--campaign"
        }
      };
      return (
        map[k] || {
          iconClass: "fa-gift",
          tokenClass: "mission-reward-token--other"
        }
      );
    },
    rewardSlotToken(item, key) {
      const entries = (item && item.reward_entries) || [];
      const k = String(key || "")
        .toLowerCase()
        .trim();
      const e = entries.find(
        x => x && x.key != null && String(x.key).toLowerCase() === k
      );
      if (!e) {
        return null;
      }
      const shown = e.display != null ? String(e.display).trim() : "";
      if (shown === "") {
        return null;
      }
      const vis = this.rewardTokenVisual(k);
      return {
        ...e,
        key: k,
        iconClass: vis.iconClass,
        tokenClass: vis.tokenClass
      };
    },
    missionRewardGridRows(item) {
      const badge = this.rewardSlotToken(item, "badge");
      const credit = this.rewardSlotToken(item, "credit");
      const row1 =
        !badge && credit ? [credit, null] : [badge, credit];
      return [
        row1,
        [
          this.rewardSlotToken(item, "inbox"),
          this.rewardSlotToken(item, "campaign")
        ]
      ];
    },
    parseRulesArray(val) {
      const parsed = this.parseJson(val);
      if (!Array.isArray(parsed)) {
        return [];
      }
      return parsed.filter(r => r && typeof r === "object");
    },
    formatEvalMode(rule) {
      const m = rule && rule.eval_mode;
      if (m == null || m === "") {
        return "—";
      }
      if (typeof m === "string") {
        return m;
      }
      if (typeof m === "object") {
        try {
          return JSON.stringify(m);
        } catch (e) {
          return String(m);
        }
      }
      return String(m);
    },
    hasEventFilter(rule) {
      return this.formatEventFilter(rule) !== "";
    },
    collectProviderCodesFromFilter(val, out) {
      if (val == null || val === "") {
        return;
      }
      if (typeof val === "string" || typeof val === "number") {
        out.push(String(val));
        return;
      }
      if (typeof val === "boolean") {
        out.push(val ? "true" : "false");
        return;
      }
      if (Array.isArray(val)) {
        val.forEach(v => this.collectProviderCodesFromFilter(v, out));
        return;
      }
      if (typeof val === "object") {
        Object.keys(val).forEach(k => {
          const nk = String(k)
            .toLowerCase()
            .replace(/_/g, "");
          if (nk === "providercode") {
            const v = val[k];
            if (Array.isArray(v)) {
              v.forEach(x => {
                if (x != null && x !== "") {
                  out.push(String(x));
                }
              });
            } else if (v != null && v !== "") {
              out.push(String(v));
            }
          } else {
            this.collectProviderCodesFromFilter(val[k], out);
          }
        });
      }
    },
    formatEventFilter(rule) {
      let f = rule && rule.event_filter;
      if (f == null || f === "") {
        return "";
      }
      if (typeof f === "string") {
        try {
          const parsed = JSON.parse(f);
          if (parsed != null && typeof parsed === "object") {
            f = parsed;
          } else {
            return f;
          }
        } catch (e) {
          return f;
        }
      }
      if (typeof f === "number" || typeof f === "boolean") {
        return String(f);
      }
      const codes = [];
      this.collectProviderCodesFromFilter(f, codes);
      const uniq = [...new Set(codes.filter(Boolean))];
      return uniq.length ? uniq.join(", ") : "";
    },
    extractNumericTargetValue(v) {
      if (v === null || v === undefined || v === "") {
        return null;
      }
      if (typeof v === "number" && Number.isFinite(v)) {
        return v;
      }
      if (typeof v === "boolean") {
        return v ? 1 : 0;
      }
      if (typeof v === "string") {
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      }
      if (Array.isArray(v)) {
        for (let i = 0; i < v.length; i++) {
          const x = this.extractNumericTargetValue(v[i]);
          if (x != null) {
            return x;
          }
        }
        return null;
      }
      if (typeof v === "object") {
        const keys = [
          "value",
          "amount",
          "target_value",
          "target",
          "count",
          "threshold"
        ];
        for (let k = 0; k < keys.length; k++) {
          const key = keys[k];
          if (Object.prototype.hasOwnProperty.call(v, key)) {
            const x = this.extractNumericTargetValue(v[key]);
            if (x != null) {
              return x;
            }
          }
        }
        const own = Object.keys(v);
        for (let i = 0; i < own.length; i++) {
          const x = this.extractNumericTargetValue(v[own[i]]);
          if (x != null) {
            return x;
          }
        }
      }
      return null;
    },
    ruleEvalModeKey(rule) {
      const m = rule && rule.eval_mode;
      if (m == null || m === "") {
        return "";
      }
      if (typeof m === "string") {
        return m.toUpperCase();
      }
      if (typeof m === "object") {
        const inner =
          m.mode || m.code || m.type || m.name || m.eval_mode;
        if (typeof inner === "string") {
          return inner.toUpperCase();
        }
      }
      return "";
    },
    formatRuleTarget(rule) {
      const raw = rule && rule.target_value;
      const evalMode = this.ruleEvalModeKey(rule);

      if (raw === null || raw === undefined || raw === "") {
        return "—";
      }

      const n = this.extractNumericTargetValue(raw);
      if (n == null || !Number.isFinite(n)) {
        if (typeof raw === "object") {
          try {
            return JSON.stringify(raw);
          } catch (e) {
            return "—";
          }
        }
        return String(raw);
      }

      const amountLike = () =>
        n.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

      switch (evalMode) {
        case "COUNT":
          return `${Math.trunc(n)}x`;
        case "AMOUNT":
        case "ACCUMULATE":
          return amountLike();
        case "DISTINCT_DAYS":
        case "STREAK":
          return String(Math.trunc(n));
        default:
          return Number.isInteger(n) ? String(Math.trunc(n)) : String(n);
      }
    },
    normalizeMissionList(dt) {
      let payload = dt;
      if (typeof payload === "string") {
        try {
          payload = JSON.parse(payload);
        } catch (e) {
          return [];
        }
      }
      if (!payload || typeof payload !== "object") {
        return [];
      }
      const raw = Array.isArray(payload.missions)
        ? payload.missions
        : Array.isArray(payload)
          ? payload
          : [];
      return raw.map(m => ({
        ...m,
        status:
          m.status === true ||
          m.status === 1 ||
          m.status === "1",
        reward_entries: this.rewardEntriesFromPayload(m.reward_payload),
        rules_parsed: this.parseRulesArray(m.rules)
      }));
    },
    getMissionList: function(isSearch) {
      let url = config.globalMissionListUrl();

      if (isSearch) {
        this.currentPage = 1;
      }

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        page_number: this.currentPage,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          try {
            if (response) {
              this.feedback.success =
                typeof response.data.status == "string"
                  ? response.data.status == "1"
                  : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                var normalized = this.normalizeMissionList(response.data.dt);
                this.totalRow =
                  normalized.length > 0 && normalized[0].totalrows != null
                    ? Number(normalized[0].totalrows)
                    : normalized.length;
                this.missionList = normalized;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status))
                  this.$helpers.showDialog(
                    this.$t("ui.alert"),
                    this.$t("error." + this.feedback.status),
                    "error"
                  );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(
              this.$t("ui.alert"),
              this.$t("error." + this.feedback.status),
              "error"
            );
          }
        },
        function() {
          this.loading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(
            this.$t("ui.alert"),
            this.$t("error." + this.feedback.status),
            "error"
          );
        }
      );
    },
    onMissionStatusChange(item, eventStatus) {
      const name = item.title_en || item.mission_id;
      const newChecked = eventStatus.srcElement.checked;
      const revert = () => {
        const prev = !newChecked;
        eventStatus.srcElement.checked = prev;
        item.status = prev;
      };

      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_mission_status_confirm", { name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmMissionStatus(item, item.status);
          } else {
            revert();
          }
        });
    },
    parseRewardPayload(item) {
      const raw = item && item.reward_payload;
      if (raw == null || raw === "") {
        return {};
      }
      if (typeof raw === "object" && !Array.isArray(raw)) {
        return raw;
      }
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch (e) {
          return {};
        }
      }
      return {};
    },
    confirmMissionStatus(item, newStatus) {
      let url = config.globalMissionStatusUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        mission_id: item.mission_id,
        new_status: newStatus
      };

      this.statusUpdatingId = item.mission_id;
      this.$http.post(url, json).then(
        function(response) {
          this.statusUpdatingId = null;
          try {
            if (response) {
              var ok =
                typeof response.data.status == "string"
                  ? response.data.status == "1"
                  : response.data.status == 1;
              var statusdesc = response.data.statusdesc;
              if (ok) {
                this.$helpers.showDialog(
                  this.$t("ui.status"),
                  this.$t("message.success"),
                  "success"
                );
              } else {
                item.status = !newStatus;
                if (!this.$helpers.handleFeedback(statusdesc))
                  this.$helpers.showDialog(
                    this.$t("ui.alert"),
                    this.$t("error." + statusdesc),
                    "error"
                  );
              }
              this.getMissionList();
            }
          } catch (error) {
            item.status = !newStatus;
            this.$helpers.showDialog(
              this.$t("ui.alert"),
              this.$t("error." + errorTags.request.failed),
              "error"
            );
            this.getMissionList();
          }
        }.bind(this),
        function() {
          this.statusUpdatingId = null;
          item.status = !newStatus;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(
            this.$t("ui.alert"),
            this.$t("error." + this.feedback.status),
            "error"
          );
          this.getMissionList();
        }.bind(this)
      );
    },
    onEditMissionGlobal(item) {
      this.missionGlobalSubmitAsStatusEnable = false;
      this.selectedMission = item;
      this.$nextTick(() => {
        const modal =
          this.$refs.editmissionglobal &&
          this.$refs.editmissionglobal.$refs.editMissionGlobal;
        if (modal && modal.show) {
          modal.show();
        }
      });
    },
    isMissionRuleEditingLocked(item) {
      const id = Number(item && item.mission_id);
      return id === 1 || id === 9 || id === 12 || id === 17;
    },
    canEditMissionRuleCard(item) {
      return this.isMissionEditAccess && !this.isMissionRuleEditingLocked(item);
    },
    ruleCardAriaLabel(item, rule) {
      const name = item && (item.title_en || item.mission_id);
      const ev = rule && rule.event_type != null ? String(rule.event_type) : "";
      if (this.isMissionRuleEditingLocked(item)) {
        const parts = [String(this.$t("ui.rules"))];
        if (name) {
          parts.push(String(name));
        }
        if (ev) {
          parts.push(ev);
        }
        return parts.join(" — ");
      }
      return (
        this.$t("ui.edit") +
        " " +
        this.$t("ui.target") +
        (name ? ": " + name : "") +
        (ev ? " — " + ev : "")
      );
    },
    rawTargetForInput(rule) {
      if (!rule) {
        return "";
      }
      const raw = rule.target_value;
      const n = this.extractNumericTargetValue(raw);
      if (n != null && Number.isFinite(n)) {
        return String(n);
      }
      if (raw != null && typeof raw === "object") {
        try {
          return JSON.stringify(raw);
        } catch (e) {
          return "";
        }
      }
      if (raw != null && raw !== "") {
        return String(raw);
      }
      return "";
    },
    parseTargetInputForSave(rule, inputStr) {
      const t = String(inputStr != null ? inputStr : "").trim();
      if (t === "") {
        return { ok: false };
      }
      const evalMode = this.ruleEvalModeKey(rule);
      if (/^[\+\-]?(?:\d+\.?\d*|\.\d+)(?:[eE][\+\-]?\d+)?$/.test(t)) {
        const asNum = Number(t);
        if (!Number.isFinite(asNum)) {
          return { ok: false };
        }
        if (
          evalMode === "COUNT" ||
          evalMode === "DISTINCT_DAYS" ||
          evalMode === "STREAK"
        ) {
          return { ok: true, value: Math.trunc(asNum) };
        }
        return { ok: true, value: asNum };
      }
      if (
        (t.startsWith("{") && t.endsWith("}")) ||
        (t.startsWith("[") && t.endsWith("]"))
      ) {
        try {
          return { ok: true, value: JSON.parse(t) };
        } catch (e) {
          return { ok: false };
        }
      }
      return { ok: true, value: t };
    },
    resolveRuleId(rule) {
      if (!rule || typeof rule !== "object") {
        return null;
      }
      const rid = rule.rule_id != null ? rule.rule_id : rule.ruleId;
      if (rid == null || rid === "") {
        return null;
      }
      return rid;
    },
    openRuleEditor(item, ri) {
      if (
        !this.isMissionEditAccess ||
        !item ||
        !item.rules_parsed ||
        this.isMissionRuleEditingLocked(item)
      ) {
        return;
      }
      const rule = item.rules_parsed[ri];
      if (!rule) {
        return;
      }
      this.ruleEditMission = item;
      this.ruleEditIndex = ri;
      this.ruleEditRuleSnapshot = rule;
      this.ruleEditTargetInput = this.rawTargetForInput(rule);
      this.$refs.editMissionRuleModal && this.$refs.editMissionRuleModal.show();
    },
    onRuleModalOk(evt) {
      evt.preventDefault();
      this.saveMissionRuleTarget();
    },
    onRuleModalShown() {
      this.$nextTick(() => {
        const cmp = this.$refs.ruleTargetInput;
        const el =
          cmp &&
          cmp.$el &&
          typeof cmp.$el.querySelector === "function" &&
          cmp.$el.querySelector("input");
        if (el && typeof el.focus === "function") {
          el.focus();
        }
      });
    },
    onRuleModalHidden() {
      this.ruleEditMission = null;
      this.ruleEditIndex = null;
      this.ruleEditRuleSnapshot = null;
      this.ruleEditTargetInput = "";
      this.ruleSaveLoading = false;
    },
    saveMissionRuleTarget() {
      const mission = this.ruleEditMission;
      const idx = this.ruleEditIndex;
      const rule = this.ruleEditRuleSnapshot;
      if (!mission || idx == null || idx < 0 || !rule) {
        return;
      }
      const parsed = this.parseTargetInputForSave(rule, this.ruleEditTargetInput);
      if (!parsed.ok) {
        this.$helpers.showDialog(
          this.$t("ui.alert"),
          this.$t("message.mission_rule_target_invalid"),
          "error"
        );
        return;
      }
      const ruleId = this.resolveRuleId(rule);
      if (ruleId == null) {
        this.$helpers.showDialog(
          this.$t("ui.alert"),
          this.$t("error." + errorTags.request.failed),
          "error"
        );
        return;
      }
      const url = config.globalMissionRuleUpdateUrl();
      const json = {
        action_by: this.$store.getters.loginId,
        audit_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        mission_id: mission.mission_id,
        rule_id: ruleId,
        target_value: parsed.value
      };
      this.ruleSaveLoading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.ruleSaveLoading = false;
          try {
            if (response) {
              var ok =
                typeof response.data.status == "string"
                  ? response.data.status == "1"
                  : response.data.status == 1;
              var status = response.data.statusdesc;
              if (ok) {
                this.$refs.editMissionRuleModal &&
                  this.$refs.editMissionRuleModal.hide();
                this.getMissionList(true);
                this.$helpers.showDialog(
                  this.$t("ui.status"),
                  this.$t("message.success"),
                  "success"
                );
              } else {
                if (!this.$helpers.handleFeedback(status)) {
                  this.$refs.editMissionRuleModal && 
                    this.$refs.editMissionRuleModal.hide();
                  this.$helpers.showDialog(
                    this.$t("ui.alert"),
                    this.$t("error." + status),
                    "error"
                  );
                }
              }
            }
          } catch (error) {
            this.ruleSaveLoading = false;
            this.$helpers.showDialog(
              this.$t("ui.alert"),
              this.$t("error." + errorTags.request.failed),
              "error"
            );
          }
        }.bind(this),
        function() {
          this.ruleSaveLoading = false;
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(
            this.$t("ui.alert"),
            this.$t("error." + this.feedback.status),
            "error"
          );
        }.bind(this)
      );
    },
    afterEditMissionGlobal() {
      this.missionGlobalSubmitAsStatusEnable = false;
      this.getMissionList();
      this.$helpers.showDialog(
        this.$t("ui.status"),
        this.$t("message.success"),
        "success"
      );
    },
    onMissionStatusEnableCancelled(item) {
      this.missionGlobalSubmitAsStatusEnable = false;
      if (item) {
        item.status = false;
      }
    },
    handleFailed(tag, status) {
      this.$helpers.showDialog(
        this.$t("ui.combine." + tag),
        this.$t("error." + status),
        "error"
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.mission-title-row {
  margin-top: 0.15rem;
}

.mission-reward-td {
  vertical-align: middle;
}

.mission-reward {
  min-height: 2.125rem;
}

.mission-reward-chips {
  min-width: 0;
  padding: 0.28rem 0.45rem;
  border: 1px solid #e4e9ef;
  border-radius: 8px;
  background: linear-gradient(165deg, #fbfcfe 0%, #f5f7fa 100%);
}

.mission-reward-chips.is-clickable {
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.mission-reward-chips.is-clickable:hover {
  background: linear-gradient(165deg, #f5f8fd 0%, #eef1f6 100%);
  border-color: #c5cdd8;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.08);
}

.mission-reward-chips.is-clickable:focus {
  outline: none;
  border-color: #4f8cff;
  box-shadow: 0 0 0 2px rgba(79, 140, 255, 0.35);
}

.mission-reward-grid {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.mission-reward-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.4rem;
  align-items: stretch;
}

.mission-reward-slot {
  min-width: 0;
  display: flex;
  align-items: center;
  min-height: 2rem;
}

.mission-reward-slot-empty {
  font-size: 0.95rem;
  padding: 0.15rem 0;
}

.mission-reward-token {
  display: inline-flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  width: 100%;
  padding: 0.2rem 0.5rem 0.2rem 0.25rem;
  border-radius: 6px;
  border: 1px solid rgba(18, 38, 63, 0.08);
  background: #fff;
  box-shadow: 0 1px 0 rgba(18, 38, 63, 0.04);
}

.mission-reward-token-ic {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  flex-shrink: 0;
  border-radius: 5px;
  font-size: 0.72rem;
  line-height: 1;
}

.mission-reward-token--badge .mission-reward-token-ic {
  color: #5b21b6;
  background: #ede9fe;
}

.mission-reward-token--credit .mission-reward-token-ic {
  color: #047857;
  background: #d1fae5;
}

.mission-reward-token--inbox .mission-reward-token-ic {
  color: #1d4ed8;
  background: #dbeafe;
}

.mission-reward-token--campaign .mission-reward-token-ic {
  color: #b45309;
  background: #ffedd5;
}

.mission-reward-token--other .mission-reward-token-ic {
  color: #475569;
  background: #e2e8f0;
}

.mission-reward-token-val {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  white-space: nowrap;
}

.mission-reward-token-val.is-campaign {
  white-space: normal;
  max-width: 100%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.mission-rules-td {
  vertical-align: middle;
}

.mission-rules-stack {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
}

.mission-rule-card {
  min-width: 0;
  padding: 0.28rem 0.45rem;
  border: 1px solid #e4e9ef;
  border-radius: 8px;
  background: linear-gradient(165deg, #fbfcfe 0%, #f5f7fa 100%);
}

.mission-rule-card.is-clickable {
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.mission-rule-card.is-clickable:hover {
  background: linear-gradient(165deg, #f5f8fd 0%, #eef1f6 100%);
  border-color: #c5cdd8;
  box-shadow: 0 1px 3px rgba(18, 38, 63, 0.08);
}

.mission-rule-card.is-clickable:focus {
  outline: none;
  border-color: #4f8cff;
  box-shadow: 0 0 0 2px rgba(79, 140, 255, 0.35);
}

.mission-rule-grid {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.mission-rule-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.4rem;
  align-items: stretch;
}

.mission-rule-slot {
  min-width: 0;
  display: flex;
  align-items: stretch;
  min-height: 2rem;
}

.mission-rule-pill {
  display: inline-flex;
  flex: 1 1 auto;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  width: 100%;
  padding: 0.2rem 0.5rem 0.2rem 0.25rem;
  border-radius: 6px;
  border: 1px solid rgba(18, 38, 63, 0.08);
  background: #fff;
  box-shadow: 0 1px 0 rgba(18, 38, 63, 0.04);
}

.mission-rule-pill-ic {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  flex-shrink: 0;
  border-radius: 5px;
  font-size: 0.72rem;
  line-height: 1;
}

.mission-rule-pill--event .mission-rule-pill-ic {
  color: #1a56b8;
  background: #e8f0fe;
}

.mission-rule-pill--mode .mission-rule-pill-ic {
  color: #465468;
  background: #eef1f5;
}

.mission-rule-pill-txt {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.2;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  word-break: break-word;
}

.mission-rule-pill--detail {
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 0;
  padding: 0.3rem 0.5rem;
}

.mission-rule-pill-stack {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
  width: 100%;
}

.mission-rule-pill-lbl {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #9aa5b5;
  line-height: 1.2;
}

.mission-rule-pill-strong {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
  word-break: break-word;
}

.mission-rule-pill--detail .mission-rule-pill-strong {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>